import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/mobile/panther_480x532.webp")